import { render, staticRenderFns } from "./PatientRubricatorRecommendations.vue?vue&type=template&id=35875b92&scoped=true"
import script from "./PatientRubricatorRecommendations.vue?vue&type=script&lang=js"
export * from "./PatientRubricatorRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35875b92",
  null
  
)

export default component.exports